import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import ListItem, { OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { injectCss } from "@insite/mobius/utilities";
import { DOMNode, domToReact } from "html-react-parser";
import * as React from "react";
import styled from "styled-components";

const Table = styled.table<InjectableCss>`
    ${injectCss}
`;

parserOptions.replace = node => {
    if (!("name" in node && "children" in node)) {
        return;
    }

    const { name, children, attribs = { style: "" }, ...rest } = node;
    const { style, class: className, ...otherAttribs } = attribs;

    otherAttribs.className = className;

    if (name && ["h1", "h2", "h3", "h4", "h5", "h6", "body", "p", "legend"].includes(name) && children) {
        return (
            <Typography css={style as any} {...otherAttribs} variant={name as TypographyProps["variant"]}>
                { }
                {children && domToReact(children as DOMNode[], parserOptions)}
            </Typography>
        );
    }
    if (name === "ul") {
        return (
            <UnorderedList css={style as any} {...otherAttribs}>
                { }
                {children && domToReact(children as DOMNode[], parserOptions)}
            </UnorderedList>
        );
    }
    if (name === "ol") {
        return (
            <OrderedList css={style as any} {...otherAttribs}>
                { }
                {children && domToReact(children as DOMNode[], parserOptions)}
            </OrderedList>
        );
    }
    if (name === "li") {
        return (
            <ListItem css={style as any} {...otherAttribs}>
                { }
                {children && domToReact(children as DOMNode[], parserOptions)}
            </ListItem>
        );
    }
    if (name === "img") {
        const { alt, ...remainingAttribs } = otherAttribs;
        return <LazyImage as="span" altText={alt} css={style as any} {...remainingAttribs} />;
    }
    if (name === "a") {
        return (
            <Link css={style as any} id={otherAttribs.name} {...otherAttribs}>
                { }
                {children && domToReact(children as DOMNode[], parserOptions)}
            </Link>
        );
    }

    if (name === "table") {
        return (
            <StyledWrapper className="table__wrapper">
                <Table css={style as any} className={className} {...otherAttribs}>
                    { }
                    {children && domToReact(children as DOMNode[], parserOptions)}
                </Table>
            </StyledWrapper>
        );
    }
};
